import { createSlice } from "@reduxjs/toolkit"
import { normalizeLanguageCode } from "../utils/language"

const langSlice = createSlice({
    name: 'lang',
    initialState: {
        language: null
    },
    reducers: {
        setLanguage: (state, action) => {
            const { lng } = action.payload
            state.language = normalizeLanguageCode(lng)
        }
    },
})

export const { setLanguage } = langSlice.actions

export default langSlice.reducer

export const selectCurrentLanguage = (state) => state.lang.language
